<template>
  <div id="bgMusic">
    <div class="bgMusicBox">
      <div class="bgMusic" @click.stop="getMnDetail">
        <img v-if="InforAudio.imgslist&&InforAudio.imgslist.length" :src="InforAudio.imgslist[0]">

        <div class="content" >
          <div class="name titlefont aqt_lang_mn" :style="{width:InforAudio.authorlist.length?'30%':'50%',lineHeight:InforAudio.authorlist.length?'3rem':'5rem'}"
               v-html="U2M(InforAudio.info?InforAudio.info.titlelang.mn?InforAudio.info.titlelang.mn:(InforAudio.info.titlelang.zh?InforAudio.info.titlelang.zh:''):'')"></div>
          <div v-if="InforAudio.authorlist.length"  style="padding-top: 1rem;width: 30%;line-height:2.5rem;" class="name titlefont aqt_lang_mn">
            <p style="overflow: hidden;text-overflow: ellipsis;
        white-space: normal;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;">
              <span style="margin-bottom: 0.5rem;" v-for="(it,ind) in InforAudio.authorlist">{{ it.mn ? it.mn: it.zh }} {{ind==(InforAudio.authorlist.length-1)?'':' — '}}</span>
            </p>
          </div>
          <div class="time aqt_lang_mn" :style="{width:InforAudio.authorlist.length?'30%':'50%',lineHeight:InforAudio.authorlist.length?'2rem':'3rem'}">
            {{ currentTime }}
            <i class="iconfont iconhr"></i>
            {{ InforAudio ? InforAudio.voratime ? InforAudio.voratime : '' : '' }}
          </div>
        </div>
        <div class="submin">
          <i :style="{cursor:cinner==0?'no-drop':''}" class='iconfont icon047caozuo_shangyishou'
             @click.stop="getLeft"></i>
        </div>
        <div class="submin">
          <i v-if="showLoding==1" class='iconfont icon24gf-play' @click.stop='playBacgcolor("play")'></i>
          <Spin v-if="showLoding==2" size="small"/>
          <i v-if="showLoding==3" class='iconfont icon24gf-pause2' @click.stop='playBacgcolor("plusp")'></i>
        </div>
        <div class="submin">
          <i :style="{cursor:cinner==(playList.length-1)?'no-drop':''}" class='iconfont icon048caozuo_xiayishou'
             @click.stop="getRight"></i>
        </div>
        <div class="close">
          <i @click.stop="close" class="iconfont iconcuohao"></i>
        </div>
      </div>
    </div>
    <audio
        style="display: none"
        :src="url"
        v-model="audio"
        controls="controls"
        id="music" ref="music"
        @timeupdate="timeupdate"
        @loadedmetadata="loadedmetadata"
    ></audio>
  </div>
</template>

<script>
export default {
  computed: {
    // 当前播放列表
    playList() {
      return this.$store.getters.playList
    },
    play_audio_id() {
      return this.$store.getters.play_audio_id
    }
  },
  data() {
    return {
      InforAudio: '',
      currentTime: '00:00',
      shouIndex: '',
      showLoding: 1,

      onOff: false, // 控制播放暂停按钮

      url: '',
      audio: 0,
      cinner: '',
    }
  },
  methods: {
    //进入详情
    getMnDetail() {
      let that = this
      that.$router.push({
        path: '/SongDetails',
        query: {
          ItemInfor: that.$crypto.set(that.InforAudio.song_base_id),
          song_annex_id: that.$crypto.set(that.InforAudio.song_annex_id),
          lib_type:sessionStorage.getItem('gcm')
        }
      })
    },
    //关闭
    close() {
      this.$store.commit('SET_Bgmusic', false)
      this.$store.commit('SET_PlayAudioId', '')
    },
    //音频播放或关闭
    playBacgcolor(val, number) {

      let that = this

      if (val == 'play') {
        that.showLoding = 2

        setTimeout(function () {
          that.$refs.music.play().then(() => {
            that.showLoding = 3

            if (that.currentTime == '00:00') {
              that.$refs.music.load()
            }
            that.$refs.music.play()

          }).catch((e) => {
            that.audio = 0
            that.currentTime = '00:00'
            that.showLoding = 1
            that.$Message.warning('ᠰᠢᠩᠭᠡᠭᠡᠭᠰᠡᠨ ᠠᠭᠤᠯᠭ᠎ᠠ  ᠶᠢ ᠪᠠᠭᠤᠯᠭᠠᠵᠤ ᠳᠡᠶᠢᠯᠦᠭᠡ ᠦᠭᠡᠢ᠃')
          })
        }, 200)
      } else if (val == 'plusp') {
        that.showLoding = 1
        that.$refs.music.pause();
      }
    },
    // 音频实时播放信息
    timeupdate(e) {
      let that = this
      // let min = '0' + parseInt(e.target.currentTime / 60)
      let min = parseInt(e.target.currentTime / 60)
      if (min < 10) {
        min = "0" + min
      }
      let sec = parseInt(e.target.currentTime) % 60
      if (sec < 10) {
        sec = "0" + sec
      }
      if (this.showLoding == 3) {
        this.currentTime = min + ':' + sec
        this.audio = e.target.currentTime
      }
      if (this.$refs.music) {
        // 如果当前时间等于总时间按钮变成停止状态
        if (e.target.currentTime === this.$refs.music.duration) {

          if (that.playList.length) {
            if (that.cinner < (that.playList.length - 1)) {
              that.getRight()
            } else {
              let id = that.playList[0].song_annex_id
              that.$store.commit('SET_PlayAudioId', id)
            }
          } else {
            this.showLoding = 1
          }

        }

      }
    },
    // 获取音频信息
    loadedmetadata(e) {
    },
    //上一首歌
    getLeft() {
      let that = this
      if (that.cinner == 0) {
        return
      } else {
        that.cinner = that.cinner - 1
        let id = that.playList[that.cinner].song_annex_id
        that.$store.commit('SET_PlayAudioId', id)
      }
    },
    //下一首歌
    getRight() {
      let that = this
      if (that.cinner == (that.playList.length - 1)) {
        return
      } else {
        that.cinner = that.cinner + 1
        let id = that.playList[that.cinner].song_annex_id
        that.$store.commit('SET_PlayAudioId', id)
      }
    },
    /********************************************************
     * 获取音频
     **********************************************************/
    getMusUrl() {
      let that = this
      let condition = {
        model:'Song',
        filetype: 'Audio',
        level: 'AQT_2023_2',
        id: that.InforAudio.song_annex_id,
        type1: 52,
        name:'点击歌曲播放',
      }
      that.$getResources(condition).then((val) => {
        if (val.code == 200) {
          that.url = that.$webcrypto.get(val.data)
          that.playBacgcolor('play')

        } else {
          that.$Message.warning(val.message);
        }
      }).catch((err) => {
      });
    },
  },
  created() {
  },
  watch: {
    play_audio_id: {
      immediate: true,
      deep: true,
      handler: function (newval) {
        let that = this
        if (that.playList.length) {
          that.InforAudio = that.playList.find(it => it.song_annex_id == newval)

          that.cinner = that.playList.indexOf(that.InforAudio)
          that.getMusUrl()
          // that.url = that.InforAudio.url ? that.InforAudio.url : ''
          // that.playBacgcolor('play')
        } else {
          that.playBacgcolor('plusp')
        }
      },
    },
  }
}
</script>

<style lang="less" scoped>
#bgMusic {
  width: 7rem;
  position: fixed;
  right: 90px;
  bottom: 1rem;
  z-index: 5555;

  .bgMusicBox {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0 0.5rem;

    .bgMusic {
      width: 8rem;
      //max-height: 30rem;
      max-height: 40rem;
      border-radius: 5px;
      box-shadow: 0px 0px 10px #E8E8E8;
      background: #ffffff;
      padding-top: 3px;
      cursor: pointer;

      img {
        width: 70%;
        max-height: 7rem;
        display: block;
        margin: 0 auto;
        border-radius: 5px 5px 0 0;
      }

      .content {
        width: 100%;
        height: 17rem;
        display: flex;
        padding: 5px 0;
        justify-content: center;

        .name {
          //width: 30%;
          height: 100%;
          font-size: 1.2rem;
          color: #888888;
          overflow: hidden;
          //line-height: 3rem;
        }

          .time {
            //width: 30%;
            height: 100%;
          font-size: 1.2rem;
          color: #888888;
          //line-height: 3rem;
          display: flex;
        }
      }

      .submin {
        width: 100%;
        height: 3rem;
        display: flex;
        align-items: center;
        justify-content: space-around;
        position: relative;


        i {
          position: absolute;
          width: 20px;
          height: 20px;
          font-size: 1.2rem;
          color: var(--themeColor);
          border: 1px solid var(--themeColor);
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;

        }
      }
      .submin:hover{
        i{
          color: #FFB600;
          background: var(--themeColor);
        }
      }

      .close {
        width: 100%;
        height: 2.5rem;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 1.4rem;
          color: #888888;
        }
      }
      .close:hover{
        i{
          color:var(--themeColor);
        }
      }
    }
    .bgMusic:hover{
      background: rgba(255,255,255,0.2);
      .content{
        .name{
          color: var(--themeColor);
        }
        .time{
          color: var(--themeColor);
        }
      }
    }
  }
}
</style>
